/**
 * @copyright 2023 Honda Motor Co., Ltd. All rights reserved.
 */

import { FC, PropsWithChildren, useCallback } from "react";
import { Dialog } from "@mui/material";
import { Map } from "./Map";

export interface MagnifyProps {
  open?: boolean;
  center: google.maps.LatLng;
  bounds: google.maps.LatLngBounds;
  heading?: number;
  onClose: () => void;
}

const mapOptions = {
  mapContainerStyle: {
    height: "400px",
    width: "400px",
  },
  options: {
    disableDefaultUI: true,
    mapTypeControl: false,
    zoomControl: false,
    gestureHandling: "none",
    keyboardShortcuts: false,
    mapId: process.env.REACT_APP_GOOGLEMAP_MAPID,
    draggable: false,
  },
};

export const Magnify: FC<PropsWithChildren<MagnifyProps>> = ({
  open = true,
  center,
  bounds,
  heading = 0,
  onClose,
  children,
}) => {
  // fitBounds.
  const onLoad = useCallback(
    (map: google.maps.Map) => {
      if (map) {
        map.fitBounds(bounds);
      }
    },
    [bounds]
  );
  return (
    <Dialog
      open={open}
      onClose={onClose}
      PaperProps={{
        sx: {
          borderRadius: "50%",
        },
      }}
    >
      <Map {...mapOptions} center={center} heading={heading} onLoad={onLoad}>
        {children}
      </Map>
    </Dialog>
  );
};
